module.exports = __webpack_public_path__ + "media/amoebic colitis.defffac7.wav";